import { RatingsGridBarsMotion } from './RatingsGridBarsMotion'
import { RatingsGridBars } from './RatingsGridBars'

interface Props {
  animate: boolean
}

export const RatingsGridMain = ({ animate }: Props) => {
  if (!animate) return <RatingsGridBars animate={false} show />

  return <RatingsGridBarsMotion />
}
